import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Sentry from '@sentry/angular';

import { persistState } from '@datorama/akita';
const storage = persistState({ key: 'client-state' });
const providers = [{ provide: 'persistStorage', useValue: storage }];

Sentry.init(environment.sentry);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers)
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
